import { t } from '@lingui/macro';

import Panel from '../../page-framework/panel/PanelDecorator';
import {
    PANEL_CATEGORIES,
    PANEL_PRIORITIES,
    STATUS_CHART_PANEL_PREVIEW_IMAGE,
} from '../../page-framework/panel/PanelRegistry';
import { panelPropTypes, panelPropDefaults } from '../../page-framework/panel/PanelPropTypes';
import StatusChartPanel from '../status-chart-panel/StatusChartPanel';
import { entityType } from '../../filters/server-filter/ServerFilter';
import { serverFilterId, timeRangeFilterId } from '../../filters';

const title = t`Server Status`;

function ServerStatusPanel() {
    return <StatusChartPanel entityType={entityType} />;
}

ServerStatusPanel.propTypes = {
    ...panelPropTypes,
};

ServerStatusPanel.defaultProps = {
    ...panelPropDefaults,
    title,
    contentHeight: 40,
    minContentHeight: 40,
    disableVerticalResize: true,
};

export default Panel({
    typeAlias: 'ServerStatusTrend',
    catalogEntry: {
        category: PANEL_CATEGORIES.SERVER,
        priority: PANEL_PRIORITIES.STATUS,
        title,
        description: t`Status trend for a selected server`,
        previewImage: STATUS_CHART_PANEL_PREVIEW_IMAGE,
        ipm: true,
    },
    filters: {
        required: [timeRangeFilterId, serverFilterId],
        optional: [],
    },
})(ServerStatusPanel);
